/**
 * Directive for the Edit Portal Page Color Scheme styles.
 */
SUGApp.directive('schemeStyles', function()
{
    return({
        restrict: 'A',
        scope: {
            schemeCss: '='
        },
        link: function(scope, el, attr){
            //initial style set
            el.text( scope.schemeCss );

            //update styles when they are changed
            scope.$on('portal_schemestyles', function (evt,val) {
                //if the event has a valid value, then update the styles
                if(    typeof val !== 'undefined'
                    && typeof val === "object"
                    && typeof val.css === "string"){
                    el.text( val.css );
                }
            }); // end $on
        }   // end link

    }); // end return

});